import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import AirportFacilityDetails from 'common/airport/AirportFacilityDetails';
import PriceDisplay from 'common/airport/PriceDisplay';
import SearchAirportOfferSchema from 'common/airport/SearchAirportOfferSchema';

const AirportStructuredDataCard = ({
    spot: {facility, currency_type: currencyType},
    destinationUrl,
    onStructuredDataClick,
}) => (
    <section
        className="AirportStructuredDataCard"
        itemProp="item"
        itemScope
        itemType="http://schema.org/Product"
        onClick={onStructuredDataClick}
    >
        <Card>
            <link
                itemProp="url"
                href={`${destinationUrl}?spot=${facility.id}`} // structured data requires each item to have a unique url
            />
            <div className="AirportStructuredDataCard-location">
                <div className="AirportStructuredDataCard-description">
                    <AirportFacilityDetails facility={facility} hideAdminLink />
                </div>
                <div
                    className="PriceContainer"
                    itemProp="offers"
                    itemScope
                    itemType="http://schema.org/Offer"
                >
                    <SearchAirportOfferSchema facilityTitle={facility.title} />
                    <PriceDisplay
                        currencyType={currencyType}
                        isDefault
                        price={facility.lowestDailyRate}
                    />
                </div>
            </div>
        </Card>
    </section>
);

AirportStructuredDataCard.propTypes = {
    spot: PropTypes.object.isRequired,
    destinationUrl: PropTypes.string.isRequired,
    onStructuredDataClick: PropTypes.func.isRequired,
};

export default AirportStructuredDataCard;
